import React, { Component } from 'react';

import { history } from '../../../state/store';
import AuthApi from '../../../api/auth';
import AuthService from '../../../state/auth.service';
import Button from '../../form/Button';
import Message from '../../form/Message';

class LoginForm extends Component {
    constructor(props, context) {
        super(props, context);

        let initialEmail = AuthService.getEmail() || '';

        this.state = {
            email: initialEmail,
            isbusy: false,
            password: '',
            errorMessage: null,
        };

        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    onChange(evt) {
        let changes = {};
        changes[evt.target.name] = evt.target.value;
        this.setState(changes);
    }

    onSubmit(event) {
        event.preventDefault();
        const { email, password } = this.state;
        this.setState({ errorMessage: null, isbusy: true }, () => {
            AuthApi.signIn(email, password)
                .then(() => {
                    this.setState({ errorMessage: null, isbusy: false });
                    // The HomePage component will redirect them to the correct place
                    history.push('/');
                })
                .catch(errorMessage => {
                    this.setState({
                        errorMessage: errorMessage,
                        isbusy: false,
                    });
                });
        });
    }

    render() {
        return (
            <form onSubmit={this.onSubmit} className="loginForm">
                <div className="form__iconfield">
                    <label htmlFor="email" title="Enter your email">
                        <i className="fa fa-envelope"></i>
                    </label>
                    <input
                        type="email"
                        name="email"
                        placeholder="you@example.com"
                        autoCapitalize="off"
                        autoCorrect="off"
                        autoFocus="autofocus"
                        required="required"
                        value={this.state.email}
                        onChange={this.onChange}
                    />
                </div>

                <div className="form__iconfield">
                    <label htmlFor="password" title="Enter your password">
                        <i className="fa fa-lock"></i>
                    </label>
                    <input
                        type="password"
                        name="password"
                        autoComplete="off"
                        placeholder="password"
                        required="required"
                        onChange={this.onChange}
                    />
                </div>

                <div className="form__buttons">
                    <Button
                        type="submit"
                        defaultText="Sign in"
                        busyText="Signing in"
                        isbusy={this.state.isbusy}
                    />
                </div>

                <div className="form__footer">
                    <Message error={this.state.errorMessage} />
                </div>
            </form>
        );
    }
}

export default LoginForm;
